import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Sidebar from '../Component/Sidebar'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'
import baseUrl from '../Constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'



function AddCase() {
    const [message, setMessage] = useState()
    const [color, setColor] = useState()
    const [loading, setLoading] = useState()
    const [caseList, setCaseList] = useState([])
    const [isOpen, setIsOpen] = useState()
    const params = useParams()
    const Patientuid = params.uid
    const navigation = useNavigate()

    const handleSubmitCase = ((e) => {
        e.preventDefault();
        console.log('ghyjubn')
        setLoading(true)
        const Patientuid = params.uid
        const token = JSON.parse(localStorage.getItem("token"))
        const patient_uid = Patientuid;
        const cases = e.target.scases.value;
        console.log(e.target.scases.value)
        const priscrption = e.target.spriscription.value;
        console.log(e.target.spriscription.value)
        axios.post(`${baseUrl}/accounts/add-case`, { patient_uid, cases, priscrption }, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')

                    }, 2000);
                    setLoading(false)
                    e.target.spriscription.value = '';
                    e.target.scases.value = '';
                    ViewCase()
                }

                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
    })

    const ViewCase = (() => {
        setLoading(true)
        const token = JSON.parse(localStorage.getItem("token"))
        axios.get(`${baseUrl}/accounts/view-cases/${Patientuid}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setCaseList(res.data.cases)
                setLoading(false)

            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
    })

    const handleItem = ((item) => {

        navigation('/edit-case', { state: { item } })
        // {case:item.cases,priscrption:item.priscrption}

    })

    const handleDelete = (uid) => {
        console.log(uid)
        const token = JSON.parse(localStorage.getItem('token'))
        axios.get(`${baseUrl}/accounts/del-cases/${uid}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 3000)
                    ViewCase()
                    setIsOpen(false)
                }
                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                }
            })
            .catch((error) => {
                console.log(error)

            })

    }

    useEffect(() => {
        ViewCase()
    }, [])

    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)' }}>
                    <div className='row p-3'>
                        <div className='col-md-12'>

                            <div className='row' >
                                {
                                    message && <div style={{ marginBottom: 10 }}>
                                        <div style={{ fontSize: 20, fontWeight: 600, color: 'white', textAlign: 'center', backgroundColor: `${color}` }}>{message}</div>
                                    </div>
                                }
                                <div className='col-md-12'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <Form onSubmit={handleSubmitCase}>
                                                <Row className='mobile'>
                                                    <Form.Group as={Col}>
                                                        <Form.Label style={{ fontSize: '1.2rem', fontWeight: "500" }}>Case:</Form.Label>
                                                        <Form.Control as="textarea" rows={3} name='scases' placeholder='Enter Case' required />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                        <Form.Label style={{ fontSize: '1.2rem', fontWeight: "500" }}>Priscription</Form.Label>
                                                        <Form.Control as="textarea" rows={3} name='spriscription' placeholder='Enter Prescription' required />
                                                    </Form.Group>

                                                </Row>
                                                <Button variant="primary" className='mt-3' type="submit">
                                                    Submit
                                                </Button>
                                            </Form>
                                        </div>

                                    </div>
                                    {/* --------------------------Table---------------------------------------------- */}
                                    <div className='row p-3'>
                                        <div className='card  '>
                                            <div className='card-body'>
                                                <div class="active-member">
                                                    <div class="table-responsive">
                                                        < table class="table table-xs" >
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Case</th>
                                                                    <th>Prescription</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            {
                                                                caseList.map((item, index) => {
                                                                    console.log(item)
                                                                    return (
                                                                        <tbody >
                                                                            <tr key={caseList.uid}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.cases}</td>
                                                                                <td>{item.priscrption}</td>
                                                                                <td>
                                                                                    <div className='d-flex gap-3'>
                                                                                        <Link to={`/add-file/${item.uid}`}>
                                                                                            <button className='btn btn-info' style={{ color: "#fff" }}> ADD FilE
                                                                                            </button>
                                                                                        </Link>

                                                                                        <button className='btn btn-danger' onClick={() => handleItem(item)}>
                                                                                            <FontAwesomeIcon icon={faEdit} />
                                                                                        </button>

                                                                                        <button className='btn btn-danger'
                                                                                            onClick={() => setIsOpen(true)}>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </button>
                                                                                        {
                                                                                            isOpen && (
                                                                                                <div className="confirmation-modal">
                                                                                                    <p>Are you sure you want to delete?</p>
                                                                                                    <button className='btn btn-danger' onClick={() => handleDelete(item.uid)}>Yes</button>
                                                                                                    <button className='btn btn-success' onClick={() => setIsOpen(false)}>No</button>
                                                                                                </div>
                                                                                            )
                                                                                        }

                                                                                    </div>

                                                                                </td>
                                                                            </tr>

                                                                        </tbody>

                                                                    )
                                                                })
                                                            }



                                                        </table>


                                                    </div>




                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div >
    )
}

export default AddCase;